module.exports = __webpack_public_path__ + "img/Yotta-logoFooter.a483a3.png";